

















































import { Component, Inject } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import StateComponent from '@/mixins/StateComponent';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { CustomerService } from '@/data/services/customer.service';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class LoginForm extends mixins(StateComponent) {

	@Inject("CustomerService") customerService!: CustomerService;

	email: string = '';
	success: boolean = false;

	constructor() {
		super();
	}

	submit() {
		this.customerService.forgotPassword(this.email).then(() => {
			this.success = true;
		}).catch((error) => {
			this.$oruga.notification.open({
				message: error.data.msg,
				position: 'top-right',
				variant: 'danger'
			})
		});
	}
}
